import React from 'react';
import { Link } from 'react-router-dom';
import { Layout, Menu, Icon } from 'antd';
import styled from 'styled-components';

const FixedSider = styled(Layout.Sider)`
  position: fixed !important;
  height: 100%;
  left: 0;
  z-index: 4;
  > div {
    height: 100%;
    max-height: 100%;
    display: flex;
    flex-direction: column;
  }
  .ant-layout-sider-zero-width-trigger {
    margin-top: -20px;
  }
`;

const BrandingContainer = styled.div`
  text-align: center;
  padding: 20px 15px;
`;

const BrandingImage = styled.img.attrs({
  src: require('images/tmt-logo-white.png')
})`
  width: 50%;
  margin: 16px 0;
`;

const BrandingText = styled.p`
  color: ${props => props.theme.white};
`;

const NavScroll = styled.div`
  max-height: 100%;
  overflow-y: auto;
  flex: 1;
`;

const SideMenu = props => {
  const { selectedKeys } = props;
  return (
    <FixedSider
      breakpoint="sm"
      collapsedWidth="0"
    >
      <BrandingContainer>
        <BrandingImage />
        <BrandingText>TakeMeTour Partner</BrandingText>
      </BrandingContainer>
      <NavScroll>
        <Menu theme="dark" mode="inline" selectedKeys={selectedKeys}>
          <Menu.Item key="product">
            <Link to="/product">
              <Icon type="appstore" />
              <span className="nav-text">Products</span>
            </Link>
          </Menu.Item>
          <Menu.Item key="transaction">
            <Link to="/transaction">
              <Icon type="profile" />
              <span className="nav-text">Transactions</span>
            </Link>
          </Menu.Item>
          <Menu.Item key="logout">
            <Link to="/logout">
              <Icon type="logout" />
              <span className="nav-text">Logout</span>
            </Link>
          </Menu.Item>
        </Menu>
      </NavScroll>
    </FixedSider>
  );
};

SideMenu.__ANT_LAYOUT_SIDER = true;

export default SideMenu;



// WEBPACK FOOTER //
// ./src/components/Layout/SideMenu.js